import { select } from 'redux-saga/effects';
import { PDFManagerFactory } from 'pdftron';
import { getInternalAnnotationVisibility, getManualAlignMode } from 'store';

/** Hide or show embedded annotations once a panel has loaded them. Manual align hides them itself and restores Redux on exit. */
export function* applyAnnotationVisibilityOnLoad() {
  const manualAlignMode: ReturnType<typeof getManualAlignMode> = yield select(getManualAlignMode);
  if (manualAlignMode.isActive) return;

  const showAnnotations: boolean = yield select(getInternalAnnotationVisibility);
  PDFManagerFactory.getPDFDocManager()?.hideOrShowInternalAnnotations(showAnnotations);
}
